// extracted by mini-css-extract-plugin
module.exports = {"inlineButton":"styles_inlineButton__3GKwD"};